/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { AgcMode_Enum, agcMode_EnumFromJSON, agcMode_EnumToJSON } from "./agc_mode";

export const protobufPackage = "flir_boson_driver";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface AgcSettings {
  plateauValue: number;
  linearPercent: number;
  tailRejection: number;
  maxGain: number;
  dampingFactor: number;
  gamma: number;
  detailGain: number;
  detailHeadroom: number;
  smoothingFactor: number;
  adeAlphaNoise: number;
  adeBetaLf: number;
  adeBetaHf: number;
  adeBetaMix: number;
  adeLutMax: number;
  adeSigmaShift: number;
  adeHpBendingAmount: number;
  adeLowLimit: number;
  adeHighLimit: number;
  adeHeadRoom: number;
  adeFootRoom: number;
  adeGain: number;
  adeLinearMix: number;
  adePaletteLowClipLimit: number;
  adePaletteHighClipLimit: number;
  mode: AgcMode_Enum;
}

function createBaseAgcSettings(): AgcSettings {
  return {
    plateauValue: 0,
    linearPercent: 0,
    tailRejection: 0,
    maxGain: 0,
    dampingFactor: 0,
    gamma: 0,
    detailGain: 0,
    detailHeadroom: 0,
    smoothingFactor: 0,
    adeAlphaNoise: 0,
    adeBetaLf: 0,
    adeBetaHf: 0,
    adeBetaMix: 0,
    adeLutMax: 0,
    adeSigmaShift: 0,
    adeHpBendingAmount: 0,
    adeLowLimit: 0,
    adeHighLimit: 0,
    adeHeadRoom: 0,
    adeFootRoom: 0,
    adeGain: 0,
    adeLinearMix: 0,
    adePaletteLowClipLimit: 0,
    adePaletteHighClipLimit: 0,
    mode: 0,
  };
}

export const AgcSettings = {
  encode(message: AgcSettings, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.plateauValue !== 0) {
      writer.uint32(13).float(message.plateauValue);
    }
    if (message.linearPercent !== 0) {
      writer.uint32(21).float(message.linearPercent);
    }
    if (message.tailRejection !== 0) {
      writer.uint32(29).float(message.tailRejection);
    }
    if (message.maxGain !== 0) {
      writer.uint32(37).float(message.maxGain);
    }
    if (message.dampingFactor !== 0) {
      writer.uint32(45).float(message.dampingFactor);
    }
    if (message.gamma !== 0) {
      writer.uint32(53).float(message.gamma);
    }
    if (message.detailGain !== 0) {
      writer.uint32(61).float(message.detailGain);
    }
    if (message.detailHeadroom !== 0) {
      writer.uint32(69).float(message.detailHeadroom);
    }
    if (message.smoothingFactor !== 0) {
      writer.uint32(77).float(message.smoothingFactor);
    }
    if (message.adeAlphaNoise !== 0) {
      writer.uint32(85).float(message.adeAlphaNoise);
    }
    if (message.adeBetaLf !== 0) {
      writer.uint32(93).float(message.adeBetaLf);
    }
    if (message.adeBetaHf !== 0) {
      writer.uint32(101).float(message.adeBetaHf);
    }
    if (message.adeBetaMix !== 0) {
      writer.uint32(109).float(message.adeBetaMix);
    }
    if (message.adeLutMax !== 0) {
      writer.uint32(117).float(message.adeLutMax);
    }
    if (message.adeSigmaShift !== 0) {
      writer.uint32(125).float(message.adeSigmaShift);
    }
    if (message.adeHpBendingAmount !== 0) {
      writer.uint32(133).float(message.adeHpBendingAmount);
    }
    if (message.adeLowLimit !== 0) {
      writer.uint32(141).float(message.adeLowLimit);
    }
    if (message.adeHighLimit !== 0) {
      writer.uint32(149).float(message.adeHighLimit);
    }
    if (message.adeHeadRoom !== 0) {
      writer.uint32(157).float(message.adeHeadRoom);
    }
    if (message.adeFootRoom !== 0) {
      writer.uint32(165).float(message.adeFootRoom);
    }
    if (message.adeGain !== 0) {
      writer.uint32(173).float(message.adeGain);
    }
    if (message.adeLinearMix !== 0) {
      writer.uint32(181).float(message.adeLinearMix);
    }
    if (message.adePaletteLowClipLimit !== 0) {
      writer.uint32(189).float(message.adePaletteLowClipLimit);
    }
    if (message.adePaletteHighClipLimit !== 0) {
      writer.uint32(197).float(message.adePaletteHighClipLimit);
    }
    if (message.mode !== 0) {
      writer.uint32(200).int32(message.mode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgcSettings {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgcSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.plateauValue = reader.float();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.linearPercent = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.tailRejection = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.maxGain = reader.float();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.dampingFactor = reader.float();
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.gamma = reader.float();
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.detailGain = reader.float();
          continue;
        case 8:
          if (tag !== 69) {
            break;
          }

          message.detailHeadroom = reader.float();
          continue;
        case 9:
          if (tag !== 77) {
            break;
          }

          message.smoothingFactor = reader.float();
          continue;
        case 10:
          if (tag !== 85) {
            break;
          }

          message.adeAlphaNoise = reader.float();
          continue;
        case 11:
          if (tag !== 93) {
            break;
          }

          message.adeBetaLf = reader.float();
          continue;
        case 12:
          if (tag !== 101) {
            break;
          }

          message.adeBetaHf = reader.float();
          continue;
        case 13:
          if (tag !== 109) {
            break;
          }

          message.adeBetaMix = reader.float();
          continue;
        case 14:
          if (tag !== 117) {
            break;
          }

          message.adeLutMax = reader.float();
          continue;
        case 15:
          if (tag !== 125) {
            break;
          }

          message.adeSigmaShift = reader.float();
          continue;
        case 16:
          if (tag !== 133) {
            break;
          }

          message.adeHpBendingAmount = reader.float();
          continue;
        case 17:
          if (tag !== 141) {
            break;
          }

          message.adeLowLimit = reader.float();
          continue;
        case 18:
          if (tag !== 149) {
            break;
          }

          message.adeHighLimit = reader.float();
          continue;
        case 19:
          if (tag !== 157) {
            break;
          }

          message.adeHeadRoom = reader.float();
          continue;
        case 20:
          if (tag !== 165) {
            break;
          }

          message.adeFootRoom = reader.float();
          continue;
        case 21:
          if (tag !== 173) {
            break;
          }

          message.adeGain = reader.float();
          continue;
        case 22:
          if (tag !== 181) {
            break;
          }

          message.adeLinearMix = reader.float();
          continue;
        case 23:
          if (tag !== 189) {
            break;
          }

          message.adePaletteLowClipLimit = reader.float();
          continue;
        case 24:
          if (tag !== 197) {
            break;
          }

          message.adePaletteHighClipLimit = reader.float();
          continue;
        case 25:
          if (tag !== 200) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgcSettings {
    return {
      plateauValue: isSet(object.plateauValue) ? globalThis.Number(object.plateauValue) : 0,
      linearPercent: isSet(object.linearPercent) ? globalThis.Number(object.linearPercent) : 0,
      tailRejection: isSet(object.tailRejection) ? globalThis.Number(object.tailRejection) : 0,
      maxGain: isSet(object.maxGain) ? globalThis.Number(object.maxGain) : 0,
      dampingFactor: isSet(object.dampingFactor) ? globalThis.Number(object.dampingFactor) : 0,
      gamma: isSet(object.gamma) ? globalThis.Number(object.gamma) : 0,
      detailGain: isSet(object.detailGain) ? globalThis.Number(object.detailGain) : 0,
      detailHeadroom: isSet(object.detailHeadroom) ? globalThis.Number(object.detailHeadroom) : 0,
      smoothingFactor: isSet(object.smoothingFactor) ? globalThis.Number(object.smoothingFactor) : 0,
      adeAlphaNoise: isSet(object.adeAlphaNoise) ? globalThis.Number(object.adeAlphaNoise) : 0,
      adeBetaLf: isSet(object.adeBetaLf) ? globalThis.Number(object.adeBetaLf) : 0,
      adeBetaHf: isSet(object.adeBetaHf) ? globalThis.Number(object.adeBetaHf) : 0,
      adeBetaMix: isSet(object.adeBetaMix) ? globalThis.Number(object.adeBetaMix) : 0,
      adeLutMax: isSet(object.adeLutMax) ? globalThis.Number(object.adeLutMax) : 0,
      adeSigmaShift: isSet(object.adeSigmaShift) ? globalThis.Number(object.adeSigmaShift) : 0,
      adeHpBendingAmount: isSet(object.adeHpBendingAmount) ? globalThis.Number(object.adeHpBendingAmount) : 0,
      adeLowLimit: isSet(object.adeLowLimit) ? globalThis.Number(object.adeLowLimit) : 0,
      adeHighLimit: isSet(object.adeHighLimit) ? globalThis.Number(object.adeHighLimit) : 0,
      adeHeadRoom: isSet(object.adeHeadRoom) ? globalThis.Number(object.adeHeadRoom) : 0,
      adeFootRoom: isSet(object.adeFootRoom) ? globalThis.Number(object.adeFootRoom) : 0,
      adeGain: isSet(object.adeGain) ? globalThis.Number(object.adeGain) : 0,
      adeLinearMix: isSet(object.adeLinearMix) ? globalThis.Number(object.adeLinearMix) : 0,
      adePaletteLowClipLimit: isSet(object.adePaletteLowClipLimit)
        ? globalThis.Number(object.adePaletteLowClipLimit)
        : 0,
      adePaletteHighClipLimit: isSet(object.adePaletteHighClipLimit)
        ? globalThis.Number(object.adePaletteHighClipLimit)
        : 0,
      mode: isSet(object.mode) ? agcMode_EnumFromJSON(object.mode) : 0,
    };
  },

  toJSON(message: AgcSettings): unknown {
    const obj: any = {};
    if (message.plateauValue !== 0) {
      obj.plateauValue = message.plateauValue;
    }
    if (message.linearPercent !== 0) {
      obj.linearPercent = message.linearPercent;
    }
    if (message.tailRejection !== 0) {
      obj.tailRejection = message.tailRejection;
    }
    if (message.maxGain !== 0) {
      obj.maxGain = message.maxGain;
    }
    if (message.dampingFactor !== 0) {
      obj.dampingFactor = message.dampingFactor;
    }
    if (message.gamma !== 0) {
      obj.gamma = message.gamma;
    }
    if (message.detailGain !== 0) {
      obj.detailGain = message.detailGain;
    }
    if (message.detailHeadroom !== 0) {
      obj.detailHeadroom = message.detailHeadroom;
    }
    if (message.smoothingFactor !== 0) {
      obj.smoothingFactor = message.smoothingFactor;
    }
    if (message.adeAlphaNoise !== 0) {
      obj.adeAlphaNoise = message.adeAlphaNoise;
    }
    if (message.adeBetaLf !== 0) {
      obj.adeBetaLf = message.adeBetaLf;
    }
    if (message.adeBetaHf !== 0) {
      obj.adeBetaHf = message.adeBetaHf;
    }
    if (message.adeBetaMix !== 0) {
      obj.adeBetaMix = message.adeBetaMix;
    }
    if (message.adeLutMax !== 0) {
      obj.adeLutMax = message.adeLutMax;
    }
    if (message.adeSigmaShift !== 0) {
      obj.adeSigmaShift = message.adeSigmaShift;
    }
    if (message.adeHpBendingAmount !== 0) {
      obj.adeHpBendingAmount = message.adeHpBendingAmount;
    }
    if (message.adeLowLimit !== 0) {
      obj.adeLowLimit = message.adeLowLimit;
    }
    if (message.adeHighLimit !== 0) {
      obj.adeHighLimit = message.adeHighLimit;
    }
    if (message.adeHeadRoom !== 0) {
      obj.adeHeadRoom = message.adeHeadRoom;
    }
    if (message.adeFootRoom !== 0) {
      obj.adeFootRoom = message.adeFootRoom;
    }
    if (message.adeGain !== 0) {
      obj.adeGain = message.adeGain;
    }
    if (message.adeLinearMix !== 0) {
      obj.adeLinearMix = message.adeLinearMix;
    }
    if (message.adePaletteLowClipLimit !== 0) {
      obj.adePaletteLowClipLimit = message.adePaletteLowClipLimit;
    }
    if (message.adePaletteHighClipLimit !== 0) {
      obj.adePaletteHighClipLimit = message.adePaletteHighClipLimit;
    }
    if (message.mode !== 0) {
      obj.mode = agcMode_EnumToJSON(message.mode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgcSettings>, I>>(base?: I): AgcSettings {
    return AgcSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgcSettings>, I>>(object: I): AgcSettings {
    const message = createBaseAgcSettings();
    message.plateauValue = object.plateauValue ?? 0;
    message.linearPercent = object.linearPercent ?? 0;
    message.tailRejection = object.tailRejection ?? 0;
    message.maxGain = object.maxGain ?? 0;
    message.dampingFactor = object.dampingFactor ?? 0;
    message.gamma = object.gamma ?? 0;
    message.detailGain = object.detailGain ?? 0;
    message.detailHeadroom = object.detailHeadroom ?? 0;
    message.smoothingFactor = object.smoothingFactor ?? 0;
    message.adeAlphaNoise = object.adeAlphaNoise ?? 0;
    message.adeBetaLf = object.adeBetaLf ?? 0;
    message.adeBetaHf = object.adeBetaHf ?? 0;
    message.adeBetaMix = object.adeBetaMix ?? 0;
    message.adeLutMax = object.adeLutMax ?? 0;
    message.adeSigmaShift = object.adeSigmaShift ?? 0;
    message.adeHpBendingAmount = object.adeHpBendingAmount ?? 0;
    message.adeLowLimit = object.adeLowLimit ?? 0;
    message.adeHighLimit = object.adeHighLimit ?? 0;
    message.adeHeadRoom = object.adeHeadRoom ?? 0;
    message.adeFootRoom = object.adeFootRoom ?? 0;
    message.adeGain = object.adeGain ?? 0;
    message.adeLinearMix = object.adeLinearMix ?? 0;
    message.adePaletteLowClipLimit = object.adePaletteLowClipLimit ?? 0;
    message.adePaletteHighClipLimit = object.adePaletteHighClipLimit ?? 0;
    message.mode = object.mode ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
